<script setup>
import { Api } from "@/service/api";
import { ref } from "vue";

const isLoading = ref(false);

const isRetry = ref(false);

async function attachGoogleAccount() {
    isLoading.value = true
    const url = await Api.getGoogleOauthUrl()

    window.after_authorization = async function() {
        isLoading.value = false
        isRetry.value = true

        setTimeout(() => {
            location.reload()
        }, 200)
    }

    window.open(url, '_blank', "top=100, left=100, width=400, height=500")

}
</script>

<template>
    <div class="flex h-full w-full flex-col items-center bg-gray-200">
        <div class="font-bold text-xl mt-40 mb-10">
            Авторизация аккаунта
        </div>
        <div class="text-lg">
            Для использования Tergum необходимо авторизоваться через Google.
        </div>
        <div class="text-lg mb-5">
            Без авторизации, вы не сможете использовать наш сервис
        </div>

        <div>
            Чтобы предоставить доступ к аккаунту, необходимо следовать инструкциям после нажатия на кнопку
        </div>
        <div
            v-on:click="attachGoogleAccount"
            class="mt-auto mb-20 px-8 py-2 rounded-md bg-blue-600 text-white font-bold text-base cursor-pointer hover:bg-blue-700 transition-colors duration-200"
        >
            <div v-if="!isLoading">
                Предоставить разрешение
            </div>
            <div v-else>
                <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>